module.exports = __webpack_public_path__ + "img/tv.34125063.svg";